import PosActions from '../../../actions/PosActions';
import NotificationActions from '../../../actions/NotificationActions';

import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';

import { endPoints as PosEndPoints } from '../../../constants/PosConstants';
import { endPoints as UserEndPoints } from '../../../constants/UserConstants';

import Toggle from '../../form/Toggle.react';
import AjaxPromises from '../../../utils/AjaxPromises';
import HttpClient from '../../../utils/HttpClient';

class ReturnForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            cashReturned        : false,
            returnedToInventory : false,
            returnReason        : '',
            reasons             : [],
            submitting          : false,
        };

        this.checkPin = this.checkPin.bind(this);
        this.submitReturn = this.submitReturn.bind(this);
    }
    
    componentDidMount() {
        this.loadReturnReasons();
    }

    loadReturnReasons() {
        var self = this;

        AjaxPromises.POST(PosEndPoints.LOAD_RETURN_REASONS, UserStore.getApiData()).then(res => {
            self.setState({
                reasons : res.Data || [],
            });
        });
    }

    checkPin() {
        var self = this;

        var formData = UserStore.getApiData();
        formData.PinCode = this.state.pin;

        if (!UserStore.getApiData().Register) {
            NotificationActions.addNotification({
                type : 'error',
                body : 'Please select a register before continuing',
            });

            return;
        }

        AjaxPromises.POST(UserEndPoints.CHECK_PIN_NUMBER,
            formData).then(res => {

                if (res.Result && res.Data[0].MgrPermission === true) {
                    self.setState({
                        pinUserId : res.Data[0].UserId,
                    }, () => {                    
                    self.submitReturn();
                    });
                } else {
                    NotificationActions.addNotification({ type : 'alert', body : 'Invalid PIN' });
                }
            }
        );
    }

    submitReturn() {
        if(this.state.submitting) {
            return;
        }
        var self = this;

        var disableSubmit = false;

        if (this.state.cashReturned === false) {
            disableSubmit = true;
        }

        if (this.state.returnedToInventory === false) {
            disableSubmit = true;
        }

        if (this.state.returnReason.length < 1) {
            disableSubmit = true;
        }

        if (disableSubmit) {
            return;
        }

        if(!UserStore.getApiData().Register) {
            NotificationActions.addNotification({
                type : 'error',
                body : 'Please select a register before continuing',
            });

            return;
        }

        this.setState({ submitting: true }, () => {
            var formData = UserStore.getApiData();
            formData.CashRet = this.state.cashReturned === '1' ? 'Yes' : 'No';
            formData.PutBackInInventory = this.state.returnedToInventory === '1' ? 'Yes' : 'No';
            formData.RegisterId = formData.Register;
            formData.ReturnReason = this.state.returnReason;
            formData.InventoryId = this.props.selected.PosId;
            formData.ShipmentId = this.props.selected.ReceiptNo;
            formData.PinUserId = this.state.pinUserId;
            formData.ReactVersion = React.version;
            
            HttpClient.post(PosEndPoints.RETURN_ITEM, formData, '', 'Item Returned Successfully').then(res =>  {
                if (!!res.Result) {
                    PosActions.transactionHistory(self.props.guest.Guest_id);
                    self.props.onReturn();
                } 
                this.setState({ submitting: false });
            });
        });
    }

    render() {
        var disableSubmit = false;
        var selectedLocation = UserStore.getState().selectedLocation;

        if (this.state.cashReturned === false) {
            disableSubmit = true;
        }

        if (this.state.returnedToInventory === false) {
            disableSubmit = true;
        }

        if (this.state.returnReason.length < 1) {
            disableSubmit = true;
        }

        disableSubmit = disableSubmit || this.state.submitting;

        return (
            <div className='return-form'>
                <div className='return-form__content'>
                    <div className='return-form__title'>
                        Return Product
                    </div>

                    <div
                        className='popup-close'
                        onClick={() => { this.props.onBack(); }}>

                        <i className='fa fa-times' aria-hidden='true' />
                    </div>

                    <div className='return-form__question'>
                        Cash Returned
                    </div>

                    <div className='return-form__answer'>
                        <Toggle
                            className='return-form__toggle'
                            label='NO'
                            value={this.state.cashReturned}
                            required='0'
                            type='no'
                            onClick={() => { this.setState({ cashReturned : '0' }); }} />

                        <Toggle
                            className='return-form__toggle'
                            label='YES'
                            value={this.state.cashReturned}
                            required='1'
                            type='yes'
                            onClick={() => { this.setState({ cashReturned : '1' }); }} />
                    </div>

                    <div className='return-form__question'>
                        Returned to inventory
                    </div>

                    <div className='return-form__answer'>
                        <Toggle
                            className='return-form__toggle'
                            label='NO'
                            value={this.state.returnedToInventory}
                            required='0'
                            type='no'
                            onClick={() => { this.setState({ returnedToInventory : '0' }); }} />

                        <Toggle
                            className='return-form__toggle'
                            label='YES'
                            value={this.state.returnedToInventory}
                            required='1'
                            type='yes'
                            onClick={() => { this.setState({ returnedToInventory : '1' }); }} />
                    </div>

                    <div className='return-form__question'>
                        Return Reason
                    </div>
                    <div className='return-form__answer'>
                    {this.state.reasons.length === 0 ? (
                        <textarea
                            className='return-form__reason'
                            value={this.state.returnReason}
                            placeholder='Reason for return...'
                            onChange={(e) => { this.setState({ returnReason : e.target.value });}}>

                        </textarea>
                    ) : (
                        <select
                            className='form-control' 
                            value={this.state.returnReason}
                            onChange={(e) => { this.setState({ returnReason : e.target.value });}}>

                            <option disabled value=''>
                                Select Return Reason
                            </option>

                            { this.state.reasons.map(r => {
                                return (
                                    <option
                                        key={r.ReturnReasonId}
                                        value={r.Reason}>

                                        {r.Reason}
                                    </option>
                                );
                            })}
                        </select>
                    )}
                    </div>

                    <div className='row mb-2'>
                        {selectedLocation.MgrPwForReturns &&
                        <div className='row mt-3 mx-4'>
                            <input
                                className='col-8'
                                type='password'
                                value={this.state.pin}
                                placeholder='PIN'
                                onChange={(e) => { this.setState({ pin : e.target.value }); }} />

                            <div
                                className={'col-4 btn-green ' + (disableSubmit ? 'btn-green__disabled' : '')}
                                onClick={this.checkPin}>
                                { this.state.submitting ? <i className="fa fa-spinner fa-pulse" aria-hidden="true" /> : 'Return' }
                            </div>
                        </div>}

                        {!selectedLocation.MgrPwForReturns &&
                        <div
                            className={'mx-auto col-4 btn-green '+(disableSubmit ? 'btn-green__disabled' : '')}
                            onClick={this.submitReturn}>
                            { this.state.submitting ? <i className="fa fa-spinner fa-pulse" aria-hidden="true" /> : 'OK' }
                        </div>}
                    </div>
                </div>
            </div>
        );
    }
}

export default ReturnForm;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/ReturnForm.react.jsx